// extracted by mini-css-extract-plugin
export default {"filter-chip":"ProductFilter_filter-chip__ZAqRU","active":"ProductFilter_active__L2JbX","filter-price-chip":"ProductFilter_filter-price-chip__sUdTn"};